<nb-card style="min-width:520px; max-width:640px">
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <h5 class="mb-0">{{ category ? 'Edit Category' : 'Add Category' }}</h5>
    <button class="btn btn-ghost-danger btn-sm" (click)="close()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body class="dialog-body">
    <form [formGroup]="categoryForm" (ngSubmit)="onSubmit()">

      <div class="mb-3">
        <label class="form-label">Category Name *</label>
        <input
          type="text"
          class="form-control"
          formControlName="name"
          placeholder="Enter category name">
        <div *ngIf="categoryForm.get('name')?.invalid && categoryForm.get('name')?.touched"
             class="text-danger small mt-1">
          Category name is required (min 2 characters)
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">URL Slug *</label>
        <input
          type="text"
          class="form-control"
          formControlName="slug"
          placeholder="auto-generated-from-name">
        <small class="form-text text-muted">Auto-generated from name. Used in URLs and must be unique.</small>
        <div *ngIf="categoryForm.get('slug')?.invalid && categoryForm.get('slug')?.touched"
             class="text-danger small mt-1">
          URL slug is required
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Description</label>
        <textarea
          class="form-control"
          formControlName="description"
          placeholder="Enter category description"
          rows="3">
        </textarea>
      </div>

      <div class="mb-3">
        <label class="form-label">Display Order</label>
        <input
          type="number"
          class="form-control"
          formControlName="displayOrder"
          placeholder="0"
          min="0">
      </div>

      <div class="mb-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" formControlName="isVisible" id="catIsVisible">
          <label class="form-check-label" for="catIsVisible">
            <strong>Visible in POS customer view</strong>
            <br>
            <small class="text-muted">Uncheck to hide this category from the customer-facing shop</small>
          </label>
        </div>
      </div>

      <div class="mb-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" formControlName="excludeFromLoyaltyDiscount" id="catExcludeLoyalty">
          <label class="form-check-label" for="catExcludeLoyalty">
            <strong>Exclude from Loyalty Discount</strong>
            <br>
            <small class="text-muted">Products in this category will not receive loyalty member discounts</small>
          </label>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Category Image</label>
        <div class="image-upload">
          <input
            type="file"
            accept="image/*"
            (change)="onImageSelected($event)"
            #fileInput
            style="display:none">
          <div class="upload-area" (click)="triggerImageUpload(fileInput)">
            <div *ngIf="!categoryImagePreview" class="upload-placeholder">
              <nb-icon icon="camera-outline" class="large-icon"></nb-icon>
              <p>Click to upload image</p>
            </div>
            <img *ngIf="categoryImagePreview" [src]="categoryImagePreview" class="preview-image" alt="Preview">
          </div>
          <button
            *ngIf="categoryImagePreview"
            type="button"
            class="btn btn-sm btn-outline-danger mt-2"
            (click)="removeImage()">
            Remove Image
          </button>
        </div>
      </div>

    </form>
  </nb-card-body>

  <nb-card-footer>
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-outline-secondary" (click)="close()">Cancel</button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onSubmit()"
        [disabled]="categoryForm.invalid || formSubmitting">
        <nb-icon *ngIf="formSubmitting" icon="loader-outline" class="spinning me-1"></nb-icon>
        {{ category ? 'Update' : 'Create' }} Category
      </button>
    </div>
  </nb-card-footer>
</nb-card>
